/**
 * Unified status enum for influencer/analyst access
 * Used in MongoDB, backend, and frontend
 */
export enum InfluencerAccessStatus {
  NOT_CONNECTED = 'NotConnected',
  ACCESS_REQUESTED = 'AccessRequested',
  INVITED = 'Invited',
  CONNECTED = 'Connected',
  DISMISSED = 'Dismissed',
  REVOKED = 'Revoked',
}

export interface Influencer {
  id: number;
  name: string;
  email: string;
  firm?: string;
  influencerGroups?: string[];
  accessStatus: InfluencerAccessStatus;
  avatarUrl?: string;
}

export interface InfluencerInviteRequest {
  influencerIds: number[];
  message?: string;
}

export interface InfluencerAccessStats {
  allInfluencers: number;
  invited: number;
  connected: number;
  notConnected: number;
}
